// extracted by mini-css-extract-plugin
module.exports = {"privacy-policy":"job-applicant-privacy-policy_privacy-policy__2llyN"};